// Copyright (c) 2021 Deere & Company

import './route.scss';
import 'font-awesome/css/font-awesome.min.css';
import {
    Redirect, Route, Switch, withRouter,
} from 'react-router-dom';
import AppHeader from '../../appmodules/common/components/app-header';
import PropTypes from 'prop-types';
import React from 'react';
import RouteMapping from './routeMapping';
import { WarrantyAlertBar } from '../../sharedmodules/components/warranty-alert-bar';
import { connect } from 'react-redux';
import { routes } from './index';

const RoutingComponent = ({ history }) => (
    <section className="jd-warranty-container">
        <WarrantyAlertBar>
            <section className="app-container-without-footer">
                {history.location.pathname !== '/unauthorizeerror' ? <AppHeader /> : null}
                <div className="padding-text" />
                <section className="app-content">
                    <Switch>
                        <RouteMapping routes={routes} />
                        <Route render={() => <Redirect to="/" />} />
                    </Switch>
                </section>
            </section>
        </WarrantyAlertBar>
    </section>
);

const mapStateToProps = (state) => ({
    ...state.oktaState,
});

RoutingComponent.propTypes = {
    history: PropTypes.object,
};

export default connect(mapStateToProps, null)(withRouter(RoutingComponent));
